// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__B4_Qm","circle":"loader_circle__uZZ8n"};